import { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  Container,
  useTheme,
  useMediaQuery,
  Card,
  CardContent,
  Stack,
  Divider,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { getAllUsers } from "../services/sheetsService";

const topicList = [
  { id: 1, name: "Full Stack" },
  { id: 2, name: "Frontend" },
  { id: 3, name: "DevOps" },
  { id: 4, name: "Data Science" },
];

const UserList = () => {
  const [userEntries, setUserEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedEntryIndex, setSelectedEntryIndex] = useState(null);
  const [fetchError, setFetchError] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const users = await getAllUsers();
        setUserEntries(users);
      } catch (err) {
        setFetchError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const handleDeleteClick = (index) => {
    setSelectedEntryIndex(index);
    setOpenDialog(true);
  };

  const confirmDelete = () => {
    setUserEntries((prev) => prev.filter((_, i) => i !== selectedEntryIndex));
    setOpenDialog(false);
    setSelectedEntryIndex(null);
  };

  const handleEdit = (index) => {
    console.log("Edit user at index:", index);
  };

  const rowHoverStyle = { "&:hover": { backgroundColor: "#f5f5f5" } };

  return (
    <Container maxWidth="lg">
      <Paper sx={{ mt: 4, p: 2, mb: 4 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Registered Students
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height={200}>
            <CircularProgress />
          </Box>
        ) : fetchError ? (
          <Typography color="error">{fetchError}</Typography>
        ) : isMobile ? (
          <Stack spacing={2} maxHeight="calc(100vh - 200px)" overflow="auto">
            {userEntries.map((entry, index) => (
              <Card key={index} variant="outlined">
                <CardContent>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {entry.name}
                  </Typography>
                  <Divider sx={{ my: 1 }} />
                  <Typography variant="body2">
                    <strong>Email:</strong> {entry.email}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Phone:</strong> {entry.mobileNo}
                  </Typography>
                  <Box mt={1}>
                    <IconButton onClick={() => handleEdit(index)} color="primary">
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => handleDeleteClick(index)}>
                      <DeleteIcon color="error" />
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Stack>
        ) : (
          <TableContainer sx={{ height: "calc(100vh - 200px)", overflow: "auto" }}>
            <Table stickyHeader sx={{ minWidth: 650, border: "1px solid #ccc" }}>
              <TableHead>
                <TableRow>
                  {["Sr.No", "Name", "Internship Topic", "Course Name", "Email", "Phone", "Registration Date", "Actions"].map((head) => (
                    <TableCell
                      key={head}
                      sx={{ color: "#fff", fontWeight: "bold", backgroundColor: "rgb(0 166 244)" }}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {userEntries.map((entry, index) => (
                  <TableRow key={index} sx={rowHoverStyle}>
                    <TableCell sx={{ padding: "12px" }}>{index + 1}</TableCell>
                    <TableCell sx={{ padding: "12px" }}>{entry.name}</TableCell>
                    <TableCell sx={{ padding: "12px" }}>
                      {topicList.find((elm) => elm.id === entry.internshipTopic)?.name || "N/A"}
                    </TableCell>
                    <TableCell sx={{ padding: "12px" }}>{entry.courseName}</TableCell>
                    <TableCell sx={{ padding: "12px" }}>{entry.email}</TableCell>
                    <TableCell sx={{ padding: "12px" }}>{entry.mobileNo}</TableCell>
                    <TableCell sx={{ padding: "12px" }}>
                      {entry.createdAt ? new Date(entry.createdAt).toLocaleDateString() : "—"}
                    </TableCell>
                    <TableCell sx={{ padding: "12px" }}>
                      <IconButton onClick={() => handleEdit(index)} color="primary">
                        <EditIcon />
                      </IconButton>
                      <IconButton onClick={() => handleDeleteClick(index)}>
                        <DeleteIcon color="error" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>Are you sure you want to delete this entry?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
            <Button onClick={confirmDelete} color="error">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Container>
  );
};

export default UserList;